import { render, staticRenderFns } from "./FundingProjectsIndex.vue?vue&type=template&id=1a27261d&"
import script from "./FundingProjectsIndex.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports